import { FTS_0012_GROUP_PARAMETER_KEY, FTS_0012_GROUP_PARAMETER_OPTIONS, FTS_0012_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = FTS_0012_TREATMENT_KEY;
const groupParameterKey = FTS_0012_GROUP_PARAMETER_KEY;
const groupParameterOptions = FTS_0012_GROUP_PARAMETER_OPTIONS;
export const logFTS0012Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};
export const useFTS0012Experiment = () => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, treatmentKey));
  const areExperimentsLoading = useAppSelector(areExperimentsLoadingSelector);
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const ownedProducts = useAppSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const isFreePortal = ownedProducts && ownedProducts.length <= 0;
  // In App experiment, only seats users
  const isEligible = hasExperimentsFetchSucceeded && isUngatedForSeats && isFreePortal && !isAcceptanceTest && isAppAuth;
  const isControl = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === (groupParameterOptions === null || groupParameterOptions === void 0 ? void 0 : groupParameterOptions.control);
  const isVariant = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === (groupParameterOptions === null || groupParameterOptions === void 0 ? void 0 : groupParameterOptions.variant);
  return {
    isEligibleForFTS0012: isEligible,
    isFTS0012Control: isControl,
    isFTS0012Variant: isVariant,
    isFTS0012Fetched: hasExperimentsFetchSucceeded,
    isFTS0012Loading: areExperimentsLoading
  };
};